import { obsDatetimeState, serverTimeState } from "libs/atoms";
import { convertZeroNumber } from "libs/utils";
import { useMemo } from "react";
import { useRecoilValue } from "recoil";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-weight: 700;
`;

const LastUpdate = styled.span`
  color: #636461;
`;

const UpdatedAt = styled.span`
  color: #9b9b9b;
`;

const Delay = styled.span<{isOver?: boolean;}>`
  color: ${props => props.isOver ? "#F79F1F" : "#72b9f0"};
`;

const LastUpdated = ({updatedAt, id, type}: {updatedAt: string, id: string, type: "image" | "info"}) => {
  const obsDatetime = useRecoilValue(obsDatetimeState);

  const {time, over} = useMemo(() => {
    if (!obsDatetime || !updatedAt) return {
      time: "00:00:00",
      over: false,
    };

    const serverTime = obsDatetime[id]
    const serverDate = new Date(`${serverTime.date} ${serverTime.time}`);

    const updatedAtDate = new Date(updatedAt);
    const diff = (serverDate.getTime() - updatedAtDate.getTime()) / 1000;

    if (diff <= 0) {
      return {
        time: "00:00:00",
        over: false,
      }
    }

    let over = false;

    if (type === "image") {
      if (id === "2" || id === "3") {
        over = diff > 3 * 60 * 60;
      } else {
        over = diff > 1 * 60 * 60;
      }
    } else {
      over = diff > 30 * 60;
    }

    const seconds = diff % 60;
    const minutes = ((diff - seconds) / 60) % 60;
    const hours = (diff - minutes * 60 - seconds) / (60 * 60);

    return {
      time: `${convertZeroNumber(hours)}:${convertZeroNumber(minutes)}:${convertZeroNumber(seconds)}`,
      over
    };
  }, [obsDatetime, updatedAt, id]);

  return <Container>
    <LastUpdate>LAST UPDATE</LastUpdate>
    <UpdatedAt>{updatedAt}</UpdatedAt>
    <Delay isOver={over}>{`+${time}`}</Delay>
  </Container>
}

export default LastUpdated;